// extracted by mini-css-extract-plugin
export default {"discount-program-report-container":"DiscountProgramReport_discount-program-report-container__6tDhp"};